import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { TipoContratoService } from '../../services/tipo-contrato.service';
import { MatDialogConfig, MatDialog } from '@angular/material';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { debounceTime } from 'rxjs/operators';
import { ContratosEditComponent } from '../contratos-edit/contratos-edit.component';
import { CellDateFormatterComponent } from '../cell-date-formatter/cell-date-formatter.component';
import { TipoContratoEditComponent } from '../tipo-contrato-edit/tipo-contrato-edit.component';

@Component({
  selector: 'app-tipo-contrato',
  templateUrl: './tipo-contrato.component.html',
  styleUrls: ['./tipo-contrato.component.scss']
})
export class TipoContratoComponent implements OnInit {

  public columnDefs: any[];
  private gridApi;
  dialogConfig: MatDialogConfig;
  public rowData: any;
  searchTerm: FormControl = new FormControl();

  public defaultColDef = {
    // set every column width
    width: 100,
    // make every column editable
    // make every column use 'text' filter by default
    filter: 'agTextColumnFilter'
  };

  createColumnDef() {
    const columnDefs = [
      { headerName: 'Tipo Contrato ID', field: 'id', cellClass: 'grid-opendialog', minWidth: 150 },
      { headerName: 'Nombre contrato', field: 'nombreContrato', cellClass: 'grid-opendialog', minWidth: 150 },
      { headerName: 'Nombre contrato PT', field: 'nombreContrato_PT', cellClass: 'grid-opendialog', minWidth: 150 },
      { headerName: 'Actualizado por', field: 'updatedByName', minWidth: 150 },
      { headerName: 'Fecha actualización', field: 'updatedDate', minWidth: 150, cellRendererFramework: CellDateFormatterComponent },
      { headerName: 'Creado por', field: 'createdByName', minWidth: 150 },
      { headerName: 'Fecha de creación', field: 'createdDate', minWidth: 150, cellRendererFramework: CellDateFormatterComponent },
    ];

    return columnDefs;
  }


  constructor(private _TipoContratoService: TipoContratoService, private _router: Router,
      private _route: ActivatedRoute, private _dialog: MatDialog, private translate: TranslateService) {

    this.columnDefs = this.createColumnDef();
    this.dialogConfig = new MatDialogConfig();
    this.dialogConfig.disableClose = false;
    this.dialogConfig.autoFocus = true;
    this.dialogConfig.closeOnNavigation = true;
  }

  ngOnInit() {
    this.getData();
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridApi.sizeColumnsToFit();
  }

  getData() {
    this._TipoContratoService.getTiposContratos().subscribe(data => this.rowData = data);
  }

  private hasSelectedRow(): boolean {
    console.log(this.gridApi.getSelectedNodes().length);
    return (this.gridApi.getSelectedNodes().length == 1);
  }

  public newItem() {

    const ref = this._dialog.open(TipoContratoEditComponent, this.dialogConfig);
    ref.componentInstance.isModal = true;
    ref.afterClosed().subscribe(result => {
      this.getData();
    });
  }

  public onCellClickedEvent($event) {

    if ($event.colDef.cellClass !== undefined && $event.colDef.cellClass.indexOf('grid-opendialog') >= 0) {

      const dlgRef = this._dialog.open(TipoContratoEditComponent, this.dialogConfig);
      dlgRef.componentInstance.id = $event.data.id;
      dlgRef.componentInstance.isModal = true;
      dlgRef.afterClosed().subscribe(result => {
        this.getData();
      });
    }
  }
}
